<template lang="pug">
div
  v-navigation-drawer(
    :value="$chat.isOpened"
    app
    color="secondary"
    temporary
    right
    width="1000"
    height="100dvh"
    @input="(val) => !val && $chat.hide()"
    style="z-index: 99"

  )
    sdo-chat(
      v-if="$chat.isOpened"
      :chatInstance="$chat.instance"
      @close="$chat.hide()"
    )
      template(#header="{ closeChat, loading }")
        .ml-4
          .text-h6: strong {{ $chat.options.title }}
          .text-body-2 {{ $chat.options.subtitle }}
          v-btn(
            v-if="$chat.options.consultationResponseMode"
            rounded
            depressed
            color="success"
            :loading="loading.close"
            @click="closeChat"
          ).mt-3.px-10 Завершить консультацию
</template>

<script>
import SdoChat from '@/modules/Chat/components/SdoChat.vue';

export default {
  name: 'ChatDrawer',
  components: {
    SdoChat,
  },
};
</script>
